import { Capacitor } from '@capacitor/core';

/**
 * Helper function to get full media URL for images, audio, and video
 * This is necessary because on native iOS/Android apps, relative URLs don't work
 * The native app needs absolute URLs pointing to the production backend
 * 
 * @param {string} url - The URL to process (can be relative or absolute)
 * @returns {string} - The full absolute URL
 */
export const getMediaUrl = (url) => {
  if (!url) return '';
  
  // If already an absolute URL, return as is
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  
  // For relative URLs, prefix with backend URL based on environment
  let backendUrl = '';
  
  if (Capacitor.isNativePlatform()) {
    // Native iOS/Android app - always use production backend
    backendUrl = 'https://app.destine.studio';
  } else if (typeof window !== 'undefined' && window.location.hostname === 'app.destine.studio') {
    // Production web app - use relative URLs (same domain)
    backendUrl = '';
  } else {
    // Preview/development - use the configured backend URL
    backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  }
  
  return backendUrl + url;
};

/**
 * Helper specifically for audio URLs - same logic as getMediaUrl
 * but with additional logging for debugging
 */
export const getAudioUrl = (url) => {
  const fullUrl = getMediaUrl(url);
  if (Capacitor.isNativePlatform()) {
    console.log('🎵 Audio URL (native):', fullUrl);
  }
  return fullUrl;
};

export default getMediaUrl;
